//登录密码
export const PASSWORD = "szwang888"
